/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  $(window).resize(function(){
    headerCustom();
    DropdownFooter();
    initScrollTop();
  })
  headerCustom();
  DropdownFooter();
  initScrollTop();
  function initScrollTop() {
            var backToTop = $('#back-top');

            $(window).scroll(function () {
                if ($(this).scrollTop() > 220) {
                    backToTop.fadeIn(400);
                } else {
                    backToTop.fadeOut(400);
                };               
            });

            backToTop.off('click.scrollTop').on('click.scrollTop', function (e) {
                e.preventDefault();
                e.stopPropagation();

                $('html, body').animate({
                    scrollTop: 0
                }, 400);
                return false;
            });
        }
  function DropdownFooter(){
            var footerTitle = $('#section-footer .Footer__Title.dropdown-mb');
            if (window.innerWidth < 641) {
                if (footerTitle.length) {
                    footerTitle.off('click.slideToggle').on('click.slideToggle', function () {
                        $(this).next().slideToggle();
                        $(this).toggleClass('open');
                    });
                }
            } else {
                footerTitle.next().css({
                    "display": ""
                });
            }
    }
  function headerCustom(){
    var headerSticky = $('#shopify-section-header');
    var annBar = $('#section-announcement').outerHeight();
    if ($('.Custom-Header').hasClass('Header--transparent')){
        headerSticky.addClass('header-block');
    }else{
        headerSticky.removeClass('header-block');
    }
  }
  var prevScrollpos = $(window).scrollTop();  
   $(window).scroll(function(){
     var headerSticky = $('#shopify-section-header');
     var annBar = $('#section-announcement').outerHeight();
     var currentScrollpos = $(window).scrollTop();
     var headerHeight =  $('#shopify-section-header').outerHeight();
    if(prevScrollpos > annBar){
      headerSticky.removeClass('header-block');
      headerSticky.addClass('is-sticky');
      $('.c-breadcrumbs').css('padding-top',headerHeight);
    }else{
      headerSticky.addClass('header-block');
      headerSticky.removeClass('is-sticky');
      $('.c-breadcrumbs').css('padding-top','0');
    }
    prevScrollpos = currentScrollpos;
   })
  $(document).on('click','[data-action="toggle-search"]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($('html').hasClass('no-scroll')){
       $('body').addClass('open-search');    
    }else{
      $('body').removeClass('open-search'); 
    }
  })
  //product styling
  if($('.Product__Styling--ProductList').length > 0){
    $('.Product__Styling--ProductList').slick({
      slidesToShow:2,
      slidesToScroll:2,
      arrows:true,
      fade:false,
      dots:true,
      autoplay: false,
      nextArrow:'<span class="slick-arrow slick-arrow-next"><svg xmlns="http://www.w3.org/2000/svg" width="8.23" height="15.047" viewBox="0 0 8.23 15.047"><path data-name="Path 106" d="M-9289.044-14283.289l7.17-7.168-7.17-7.172" transform="translate(9289.397 14297.982)" fill="none" stroke="#444" stroke-width="1"/></svg></span>',
      prevArrow:'<span class="slick-arrow slick-arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" width="8.229" height="15.047" viewBox="0 0 8.229 15.047"><g data-name="Group 18461" transform="translate(0.706 0.354)"><path data-name="Path 106" d="M-9281.875-14283.289l-7.169-7.168,7.169-7.172" transform="translate(9289.045 14297.629)" fill="none" stroke="#444" stroke-width="1"/></g></svg></span>',
      appendDots: '.custom-dotsBottom',
      appendArrows: '.custom-dotsBottom'
    });
  } 

  $(".foot-link").click(function(e) {
    e.preventDefault();
      var aid = $(this).attr("href");
      var top = $(aid).offset().top - 300;
      var topmb = $(aid).offset().top - 200;
    if ($(window).width()>768){
      $('html,body').animate({scrollTop: top}, 250);
    }else{
       $('html,body').animate({scrollTop: topmb}, 250);
    }
  });
  if ($('body').hasClass('template-blog')){
      var scrollX = $('.template-blog .Blog__TagList .Heading.is-active').offset().left - 200;
      $('.template-blog .Blog__TagList').animate({
          'scrollLeft': + scrollX
      }, '500');
  }
   $('.show-category').on('click', function () {
     $(".Collapsible__Button.Heading.u-h6").each(function() {  
      if ($(this).val() == 'カテゴリー'){        
        $(this).parent().css( "overflow", "visible" );
        $(this).attr("aria-expanded", "true");
        $(this).parent().find( ".custom-dr" ).css({"overflow": "visible", "height": "auto"});
      }
    });
   })
})